<!-- <mat-toolbar style="height:72px"> -->
    <!-- <div class="col-md-12 logo"></div>
    <span></span>
    <span class="menu-spacer"></span>
    <div fxShow="true" fxHide.lt-md>
        <a [routerLink]="[ '/', 'dashboard' ]" mat-button>Inicio</a>
        <a [routerLink]="[ '/', 'dashboard' ]" mat-button>Fondos e Inversion</a>
        <a [routerLink]="[ '/', 'dashboard' ]" mat-button>Vida y Familia</a>
        <a [routerLink]="[ '/', 'dashboard' ]" mat-button>Salud</a>
        <a [routerLink]="[ '/', 'benefits' ]" mat-button>Beneficios</a>
        <button mat-raised-button color="primary">SOAT</button>
        <button mat-stroked-button disabled>Agencia virtual</button>
        <button mat-button color="primary">Nosotros</button>
        <button mat-button color="primary">Nuestro respaldo</button>
    </div> -->
<div
fxLayout
fxLayoutAlign="start end"
fxLayoutAlign.lt-md="space-between center">

        <div class="col-md-12 logo">
          <img src="/assets/images/logo.png" alt="" />
        </div>
        <button mat-icon-button [matMenuTriggerFor]="menu" fxHide.gt-sm>
            <mat-icon>menu</mat-icon>
        </button>
            <div fxLayout fxLayoutAlign="space-between" class="all_space" fxHide.lt-md>
                <div fxLayout fxLayoutAlign="start end">
<!--                <a [routerLink]="[ '/', 'dashboard' ]" mat-button>Inicio</a>-->
                <a [routerLink]="[ '/', 'home' ]" mat-button>Inicio</a>
                <a href="#" mat-button>Fondos e Inversion</a>
                <a href="#" mat-button>Vida y Familia</a>
                <a href="#" mat-button>Salud</a>
                <a [routerLink]="[ '/', 'benefits' ]" mat-button>Beneficios</a>
                <button mat-raised-button color="primary">SOAT</button>
                </div>
                <div fxLayout="column" fxLayoutAlign="start end">
                <div fxLayout>
                    <button mat-button color="primary">Nosotros</button>
                    <button mat-button color="primary">Nuestro respaldo</button>
                </div>
                <button mat-stroked-button disabled>Agencia virtual</button>
                </div>
            </div>
        </div>

<mat-menu #menu="matMenu">
    <button mat-menu-item>Inicio</button>
    <button mat-menu-item>Fondos e Inversion</button>
    <button mat-menu-item>Vida y Familia</button>
    <button mat-menu-item>Salud</button>
    <button mat-menu-item>Beneficios</button>
    <mat-divider></mat-divider>
    <button mat-menu-item>SOAT</button>
    <mat-divider></mat-divider>
    <button mat-menu-item>Nosotros</button>
    <button mat-menu-item>Nuestro respaldo</button>
    <mat-divider></mat-divider>
    <button mat-menu-item>Agencia Virtual</button>
</mat-menu>
